import Splide from '@splidejs/splide';

/**
 * Initializes the Sliders component.
 */

const Sliders = () => {

    const splideNext = document.querySelector('.reviews__wrapper-right-title-navigation-next');
    const splidePrev = document.querySelector('.reviews__wrapper-right-title-navigation-prev');

    const singleProductSlider = document.querySelector('.single-product-main-slider');
    const singleProductThumbs = document.querySelector('.single-product-thumbnails-slider');
    const reviewsSecond       = document.querySelector('.second-swiper-theme');
    const reviewsFirst        = document.querySelector('.first-swiper-theme');

    // Single product
    const allGalleryLinks = document.querySelectorAll('.woocommerce-product-gallery__image a');

    // Hero section slider:
    const heroSlider = document.querySelector('.hero-grid__wrapper-slider');

    const twoColumnsSlider = document.querySelector('.two-columns-with-slider__wrapper-right-slider');

    if(twoColumnsSlider) {
        const twoColumnsNext = document.querySelector('.two-columns-with-slider__wrapper-right-slider-navigation-next');
        const twoColumnsPrev = document.querySelector('.two-columns-with-slider__wrapper-right-slider-navigation-prev');

        var twoColumns = new Splide( '.two-columns-with-slider__wrapper-right-slider', {
            type: 'loop',
            perPage: 1,
            pagination  : false,
            arrows    : false,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: "play"
            }
        }).mount();

        if(twoColumnsNext) {
            twoColumnsNext.addEventListener('click', e => {
                twoColumns.go('+1')
            })
        }
        
        if(twoColumnsPrev) {
            twoColumnsPrev.addEventListener('click', e => {
                twoColumns.go('-1')
            })
        }
    }

    if(heroSlider) {
        var main = new Splide( '.hero-grid__wrapper-slider', {
            perPage: 1,
            rewind    : true,
            pagination: false,
            arrows    : false,
            gap       : 50,
        }).mount();
    }

    if(allGalleryLinks) {
        allGalleryLinks.forEach(galleryItem => {
            galleryItem.addEventListener('click',function(event) {
                event.preventDefault();
            })
        });
    }

    if(singleProductSlider) {
        var main = new Splide( '.single-product-main-slider', {
            rewind    : true,
            pagination: false,
            arrows    : false,
            gap       : 50,
        });
    
        if(singleProductThumbs) {
            var thumbnails = new Splide( '.single-product-thumbnails-slider', {
                direction: 'ttb',
                gap         : 15,
                pagination  : false,
                isNavigation: true,
                arrows    : false,
                fixedWidth : 80,
                fixedHeight: 80,
                height: 270,
                heightRatio: 1,
                perPage: 3,
            });

            main.sync( thumbnails );
            main.mount();
        } else {
            main.mount();
        }
        
        if(thumbnails) {
            thumbnails.mount();
        }

    }

    if(reviewsSecond) {
        const secondThemeSlider = new Splide('.second-swiper-theme', {
            type: 'loop',
            perPage: 2,
            pagination  : true,
            arrows    : false,
            gap: 30,
            classes: {
                pagination: 'reviews__wrapper-right-pagination',
            },
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: "play"
            },
            breakpoints: {
                575: {
                    perPage: 1,
                }
            }
        }).mount();
    
        splideNext.addEventListener('click', e => {
            secondThemeSlider.go('+1')
        })
        
        splidePrev.addEventListener('click', e => {
            secondThemeSlider.go('-1')
        })
    }

    if (reviewsFirst) {
        const firstThemeSlider = new Splide('.first-swiper-theme', {
            type: 'loop',
            perPage: 1,
            pagination: true,
            arrows: false,
            classes: {
                pagination: 'reviews__wrapper-right-pagination',
            },
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: "play"
            }
        }).mount();
    
        const secondThemeSlider = new Splide('.first-swiper-theme-image', {
            type: 'loop',
            perPage: 1,
            pagination: false,
            arrows: false,
            reducedMotion: {
                interval: 4000,
                speed: 800,
                autoplay: "play"
            }
        }).mount();
    
        // Synchronize sliders
        firstThemeSlider.on('move', (newIndex) => {
            secondThemeSlider.go(newIndex);
        });
    
        secondThemeSlider.on('move', (newIndex) => {
            firstThemeSlider.go(newIndex);
        });
    }

    const productsGridSlider = document.querySelector('.products-grid__wrapper-slider');

    if (productsGridSlider) {
        let productGridSlider = null; // Ustaw początkowo na null
    
        function initSplideFunction() {
            const screenWidth = window.innerWidth;
    
            if (screenWidth >= 768) {
                // Jeśli szerokość jest większa lub równa 768px, zainicjuj Splide, jeśli nie istnieje
                if (!productGridSlider) {  // Sprawdź, czy Splide nie został już zainicjowany
                    const productGridNext = document.querySelector('.products-grid__slider-navigation-next');
                    const productGridPrev = document.querySelector('.products-grid__slider-navigation-prev');
    
                    productGridSlider = new Splide('.products-grid__wrapper-slider', {
                        type: 'loop',
                        perPage: 4,
                        pagination: true,
                        arrows: false,
                        classes: {
                            pagination: 'reviews__wrapper-right-pagination',
                        },
                        gap: 40,
                        loop: true,
                        autoplay: true,
                        reducedMotion: {
                            interval: 5000,
                            speed: 800,
                            autoplay: "play"
                        }
                    }).mount();
    
                    productGridNext.addEventListener('click', () => {
                        productGridSlider.go('+1');
                    });
    
                    productGridPrev.addEventListener('click', () => {
                        productGridSlider.go('-1');
                    });
                }
            } else {
                // Jeśli szerokość jest mniejsza niż 768px, zniszcz Splide, jeśli istnieje
                if (productGridSlider) {
                    productGridSlider.destroy(true, true);  // Zniszcz instancję Splide
                    productGridSlider = null; // Ustaw zmienną na null, aby można było ponownie utworzyć instancję powyżej
                }
            }
        }
    
        // Inicjalizacja przy załadowaniu
        initSplideFunction();
    
        // Dodaj event listener na zdarzenie resize
        window.addEventListener('resize', initSplideFunction);
    }
};

export default Sliders;
